import * as React from "react";

const CartEisCertification: React.FC = () => {
    return (
        <svg
            width="11px"
            height="8px"
            viewBox="0 0 11 8"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <polygon
                    fill="currentColor"
                    points="10.498 3.84 9.954 4.355 4.242 9.765 3.727 10.252 3.211 9.765 .544 7.241 0 6.725 1.031 5.635 1.575 6.151 3.727 8.188 8.923 3.266 9.466 2.75 10.498 3.84"
                    transform="translate(0 -2.5)"
                />
            </g>
        </svg>
    );
};

export default React.memo(CartEisCertification);
